import {
  RouteToAllPostersPage,
  RouteToArtistPage,
  RouteToPostersPage,
  RouteToSearchPage,
} from '@/common/routes/ExternalRoutes';
import { RouteToProductPage } from '@/modules/ProductPage/ProductPageConfig';

const SeoLinks = [
  {
    name: 'Categories',
    values: [
      {
        name: 'Anime posters',
        link: RouteToPostersPage('anime'),
      },
      {
        name: 'Movie posters',
        link: RouteToPostersPage('movies'),
      },
      {
        name: 'Horror posters',
        link: RouteToPostersPage('horror-movie'),
      },
      {
        name: 'Halloween posters',
        link: RouteToPostersPage('vintage-halloween'),
      },
      {
        name: 'Propaganda posters',
        link: RouteToPostersPage('propaganda'),
      },
      {
        name: 'Motivational posters',
        link: RouteToPostersPage('motivational'),
      },
      {
        name: 'Cool posters',
        link: RouteToPostersPage('cool'),
      },
      {
        name: 'Vintage posters',
        link: RouteToPostersPage('vintage'),
      },
      {
        name: 'Space posters',
        link: RouteToPostersPage('space'),
      },
      {
        name: 'Car posters',
        link: RouteToPostersPage('cars'),
      },
      {
        name: 'Japanese posters',
        link: RouteToPostersPage('japanese'),
      },
      {
        name: 'Nature posters',
        link: RouteToPostersPage('nature'),
      },
      {
        name: 'Animal posters',
        link: RouteToPostersPage('animals'),
      },
      {
        name: 'Christmas posters',
        link: RouteToPostersPage('vintage-christmas'),
      },
      {
        name: 'Metal posters',
        link: RouteToAllPostersPage(),
      },
      {
        name: 'Album posters',
        link: RouteToPostersPage('music'),
      },
      {
        name: 'UK posters',
        link: RouteToPostersPage('united-kingdom'),
      },
      {
        name: 'Fashion posters',
        link: RouteToPostersPage('fashion'),
      },
      {
        name: 'Text art posters',
        link: RouteToPostersPage('text-art'),
      },
      {
        name: 'Cute posters',
        link: RouteToPostersPage('cute'),
      },
    ],
  },
  {
    name: 'Brands',
    values: [
      {
        name: 'Star Wars posters',
        link: RouteToArtistPage({ licensed: true, nick: 'star-wars' }),
      },
      {
        name: 'Cyberpunk 2077 posters',
        link: RouteToArtistPage({ licensed: true, nick: 'cyberpunk-2077' }),
      },
      {
        name: 'Marvel posters',
        link: RouteToArtistPage({ licensed: true, nick: 'marvel' }),
      },
      {
        name: 'DnD posters',
        link: RouteToArtistPage({ licensed: true, nick: 'dungeons-and-dragons' }),
      },
      {
        name: 'Jurassic park posters',
        link: RouteToArtistPage({ licensed: true, nick: 'jurassic-world' }),
      },
      {
        name: 'Elden Ring posters',
        link: RouteToArtistPage({ licensed: true, nick: 'elden-ring' }),
      },
      {
        name: 'Disco Elysium posters',
        link: RouteToArtistPage({ licensed: true, nick: 'disco-elysium' }),
      },
      {
        name: 'League of Legends posters',
        link: RouteToArtistPage({ licensed: true, nick: 'league-of-legends' }),
      },
      {
        name: 'Fallout posters',
        link: RouteToArtistPage({ licensed: true, nick: 'fallout' }),
      },
      {
        name: 'South Park posters',
        link: RouteToArtistPage({ licensed: true, nick: 'south-park' }),
      },
      {
        name: 'Stranger Things posters',
        link: RouteToArtistPage({ licensed: true, nick: 'stranger-things-series' }),
      },
      {
        name: 'Transformers poster',
        link: RouteToArtistPage({ licensed: true, nick: 'transformers' }),
      },
      {
        name: 'Ghost band posters',
        link: RouteToArtistPage({ licensed: true, nick: 'ghost' }),
      },
      {
        name: 'Squid Game posters',
        link: RouteToArtistPage({ licensed: true, nick: 'squid-game' }),
      },
      {
        name: 'Peaky Blinders posters',
        link: RouteToArtistPage({ licensed: true, nick: 'peaky-blinders' }),
      },
      {
        name: 'NASA posters',
        link: RouteToArtistPage({ licensed: true, nick: 'inspired-by-nasa' }),
      },
      {
        name: 'Witcher posters',
        link: RouteToArtistPage({ licensed: true, nick: 'witcher-3' }),
      },
      {
        name: 'Call of Duty posters',
        link: RouteToArtistPage({ licensed: true, nick: 'call-of-duty' }),
      },
      {
        name: 'Dark Souls posters',
        link: RouteToArtistPage({ licensed: true, nick: 'dark-souls' }),
      },
      {
        name: 'DC posters',
        link: RouteToArtistPage({ licensed: true, nick: 'dc-comics' }),
      },
      {
        name: 'Elvis Presley posters',
        link: RouteToArtistPage({ licensed: true, nick: 'elvis-presley' }),
      },
      {
        name: 'AvP posters',
        link: RouteToArtistPage({ licensed: true, nick: 'alien-vs-predator' }),
      },
      {
        name: 'Warhammer posters',
        link: RouteToArtistPage({ licensed: true, nick: 'warhammer' }),
      },
      {
        name: 'Blade Runner posters',
        link: RouteToArtistPage({ licensed: true, nick: 'blade-runner' }),
      },
      {
        name: 'Grateful Dead posters',
        link: RouteToArtistPage({ licensed: true, nick: 'grateful-dead' }),
      },
      {
        name: 'Chilling Adventures of Sabrina posters',
        link: RouteToArtistPage({ licensed: true, nick: 'chilling-adventures' }),
      },
      {
        name: 'Mortal Kombat posters',
        link: RouteToArtistPage({ licensed: true, nick: 'mortal-kombat' }),
      },
      {
        name: 'Riverdale posters',
        link: RouteToArtistPage({ licensed: true, nick: 'riverdale' }),
      },
      {
        name: 'Supernatural posters',
        link: RouteToArtistPage({ licensed: true, nick: 'supernatural' }),
      },
      {
        name: 'Monopoly posters',
        link: RouteToArtistPage({ licensed: true, nick: 'monopoly' }),
      },
    ],
  },
  {
    name: 'Searches',
    values: [
      {
        name: 'Cat posters',
        link: RouteToSearchPage('cat-poster'),
      },
      {
        name: 'Art deco posters',
        link: RouteToSearchPage('art-deco'),
      },
      {
        name: 'Aesthetic posters',
        link: RouteToSearchPage('aesthetic'),
      },
      {
        name: 'Beer posters',
        link: RouteToSearchPage('beer'),
      },
      {
        name: 'Coffee posters',
        link: RouteToSearchPage('coffee-poster'),
      },
      {
        name: 'Wanted posters',
        link: RouteToSearchPage('wanted'),
      },
      {
        name: 'Posters for room',
        link: RouteToSearchPage('room'),
      },
      {
        name: 'Album cover posters',
        link: RouteToSearchPage('album'),
      },
      {
        name: 'Preppy posters',
        link: RouteToSearchPage('preppy'),
      },
      {
        name: 'Prom posters',
        link: RouteToSearchPage('prom'),
      },
      {
        name: 'Football posters',
        link: RouteToSearchPage('football-posters'),
      },
      {
        name: 'Black light posters',
        link: RouteToSearchPage('black-light'),
      },
      {
        name: 'Alien posters',
        link: RouteToSearchPage('alien'),
      },
      {
        name: 'Music posters',
        link: RouteToSearchPage('music'),
      },
      {
        name: 'Mental health posters',
        link: RouteToSearchPage('mental'),
      },
      {
        name: 'Rap posters',
        link: RouteToSearchPage('rap'),
      },
      {
        name: 'Batman posters',
        link: RouteToSearchPage('batman'),
      },
      {
        name: 'Sports posters',
        link: RouteToSearchPage('sport'),
      },
      {
        name: 'Minimalist movie posters',
        link: RouteToSearchPage('minimal-movie'),
      },
      {
        name: 'Banksy posters',
        link: RouteToSearchPage('banksy'),
      },
      {
        name: 'Retro posters',
        link: RouteToSearchPage('retro'),
      },
      {
        name: '80s posters',
        link: RouteToSearchPage('80s'),
      },
      {
        name: 'Boxing posters',
        link: RouteToSearchPage('boxing'),
      },
      {
        name: 'Kindness posters',
        link: RouteToSearchPage('kindness'),
      },
      {
        name: 'Black and White posters',
        link: RouteToSearchPage('black-and-white'),
      },
      {
        name: 'Espresso beans posters',
        link: RouteToSearchPage('coffee-bean'),
      },
      {
        name: '90s posters',
        link: RouteToSearchPage('90s'),
      },
      {
        name: 'Bedroom posters',
        link: RouteToSearchPage('bedroom'),
      },
      {
        name: 'Travel posters',
        link: RouteToSearchPage('travel'),
      },
      {
        name: 'Reading posters',
        link: RouteToSearchPage('reading'),
      },
    ],
  },
  {
    name: 'Artworks',
    values: [
      {
        name: 'Spiderverse poster',
        link: RouteToProductPage({ externalId: '1831234' }),
      },
      {
        name: 'Revenge Of The Sith poster',
        link: RouteToProductPage({ externalId: '268374' }),
      },
      {
        name: 'Infinity War poster',
        link: RouteToProductPage({ externalId: '4340857' }),
      },
      {
        name: 'Memento Mori Definition poster',
        link: RouteToProductPage({ externalId: '6523023' }),
      },
      {
        name: 'Obey poster',
        link: RouteToProductPage({ externalId: '4992712' }),
      },
      {
        name: 'To my son from dad poster',
        link: RouteToProductPage({ externalId: '4632971' }),
      },
      {
        name: 'Monkey meme poster',
        link: RouteToProductPage({ externalId: '4489095' }),
      },
      {
        name: 'Phantom Menace poster',
        link: RouteToProductPage({ externalId: '268372' }),
      },
      {
        name: 'Voyager 1 Golden Record poster',
        link: RouteToProductPage({ externalId: '2055610' }),
      },
      {
        name: 'Webhead poster',
        link: RouteToProductPage({ externalId: '4344415' }),
      },
      {
        name: 'Arsenal crest poster',
        link: RouteToProductPage({ externalId: '5404208' }),
      },
      {
        name: 'Commander Rex helmet poster',
        link: RouteToProductPage({ externalId: '4630317' }),
      },
      {
        name: 'Nobody Cares Work Harder poster',
        link: RouteToProductPage({ externalId: '2326430' }),
      },
      {
        name: 'Ares God of War poster',
        link: RouteToProductPage({ externalId: '6075930' }),
      },
      {
        name: 'Revenge Of The Jedi poster',
        link: RouteToProductPage({ externalId: '1122537' }),
      },
      {
        name: 'Loki poster',
        link: RouteToProductPage({ externalId: '5030624' }),
      },
      {
        name: 'Star Wars propaganda poster',
        link: RouteToProductPage({ externalId: '270786' }),
      },
      {
        name: 'Captain America Civil War poster',
        link: RouteToProductPage({ externalId: '4340853' }),
      },
      {
        name: 'Guardians of the Galaxy Vol 3 poster',
        link: RouteToProductPage({ externalId: '6505558' }),
      },
      {
        name: 'Pathetic duck poster',
        link: RouteToProductPage({ externalId: '5335218' }),
      },
    ],
  },
];

export default SeoLinks;
